const ADS_CLIENT = import.meta.env.VITE_ADSENSE_CLIENT_ID || 'ca-pub-2005667439674919';
const SCRIPT_SRC = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADS_CLIENT}`;

let loadPromise: Promise<void> | null = null;

/**
 * Loads the AdSense script once. Deferred from initial HTML so critical path stays short.
 */
export function loadAdsenseScript(): Promise<void> {
  if (typeof document === 'undefined') return Promise.resolve();
  if (document.querySelector(`script[src^="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle"]`)) {
    return Promise.resolve();
  }
  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.async = true;
    s.src = SCRIPT_SRC;
    s.crossOrigin = 'anonymous';
    s.onload = () => resolve();
    s.onerror = () => reject(new Error('AdSense script failed to load'));
    document.head.appendChild(s);
  });

  return loadPromise;
}

/**
 * After window load, schedule AdSense on idle so LCP / main thread stay prioritized.
 */
export function scheduleDeferredAdsenseLoad(): void {
  if (typeof window === 'undefined') return;

  const run = () => {
    void loadAdsenseScript().catch(() => {
      /* non-fatal */
    });
  };

  const onLoad = () => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(run, { timeout: 5000 });
    } else {
      window.setTimeout(run, 2000);
    }
  };

  if (document.readyState === 'complete') onLoad();
  else window.addEventListener('load', onLoad, { once: true });
}
